import type { IMedia } from "src/model/unityObject";
import getMediaMetadata from "./getMediaMetadata";

const hasMediaBeenGeneratedByAi = (media: IMedia): boolean => {
  const metadata = getMediaMetadata(media);
  return Boolean(metadata && typeof metadata === "object" && metadata.initialPrompt);
};

export default hasMediaBeenGeneratedByAi;
